import { Block, Inline, Text } from 'slate';

import { isViewerURL } from 'libs/rendering/utils';

const normalizePreview = (editor, error) => {
  const { node } = error;
  const { data, text } = node;
  const previewData = {
    title: '',
    alt: text,
    href: data.get('url') || data.get('href'),
  };
  const previewTemplate = {
    type: 'preview',
    nodes: [],
    data: previewData,
  };
  const previewNode = Inline.create(previewTemplate);
  editor.replaceNodeByKey(node.key, previewNode);
};

export const schema = {
  inlines: {
    image: { isVoid: true },
    video: { isVoid: true },
    preview: { isVoid: true },
    link: { data: { href: href => !!href } },
  },
  blocks: {
    'image-block': { isVoid: true },
    'video-block': { isVoid: true },
    'preview-block': { isVoid: true },
  },
  rules: [
    {
      match: { object: 'text' },
      text: text => !text.includes('\r'),
      normalize: (editor, error) => {
        const { node } = error;
        const newTextNode = Text.create({
          text: node.text.replace('\r', ''),
          marks: node.marks,
        });
        editor.replaceNodeByKey(node.key, newTextNode);
      },
    },
    {
      match: { object: 'inline' },
      type: type => !['hardbreak', 'softbreak'].includes(type),
      normalize: (editor, error) => {
        const { node } = error;
        editor.removeNodeByKey(node.key);
      },
    },
    {
      match: { type: 'paragraph' },
      text: text => text !== '​',
      normalize: (editor, error) => {
        const { node } = error;
        const emptyParagraph = Block.create('paragraph');
        editor.replaceNodeByKey(node.key, emptyParagraph);
      },
    },
    {
      match: {
        object: 'block',
        type: type => ['unordered_list', 'ordered_list'].includes(type),
      },
      nodes: [{ match: { type: 'list_item' } }],
      normalize: (editor, error) => {
        const { child } = error;
        return () => editor.wrapNodeByKey(child.key, 'list_item');
      },
    },
    {
      match: { object: 'block', type: 'list_item' },
      nodes: [{ match: { object: 'block' } }],
      normalize: (editor, error) => {
        const { child } = error;
        return () => editor.wrapNodeByKey(child.key, 'unstyled');
      },
    },
    {
      match: {
        object: 'inline',
        type: type => ['image', 'video', 'preview'].includes(type),
      },
      parent: {
        type: type => ['paragraph', 'unstyled'].includes(type),
        text: text => text !== '',
      },
      normalize: (editor, error) => {
        const { node } = error;
        const { type, data, nodes } = node;
        const parent = editor.value.document.getParent(node.key);
        const blockTemplate = {
          type: `${type}-block`,
          nodes,
          data,
        };
        const blockNode = Block.create(blockTemplate);
        editor.replaceNodeByKey(parent.key, blockNode);
      },
    },
    {
      match: { type: 'link' },
      data: {
        href: link => !isViewerURL(link),
      },
      normalize: normalizePreview,
    },
    {
      match: { type: 'linkified-link' },
      data: {
        url: url => !isViewerURL(url),
      },
      normalize: normalizePreview,
    },
  ],
};
